import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

class HtmlPopup extends Component {
  constructor(props, context) {
    super(props, context);
    var value = props.value;
    try {
      value = JSON.parse(value);
    } catch (e) {
      value=null;
    }

    this.state = { value: value };
  }

  componentWillReceiveProps(nextProps) {
    var value;
    if(nextProps.value!=null) {
      try {
        value = JSON.parse(nextProps.value);
      } catch (e) {
        value=null;
      }
      this.state.value = value;
    }
  }

  render() {
    var input = null;
    var readOnly = null;

    if(this.props.readOnly && this.state.value!=null) {
      input = null;
      readOnly = (
        <p className="formOnlyReadData">{this.state.value[0]}</p>
      );
      if(this.props.value!=null) {
        readOnly = (
          <p className="formOnlyReadData">
            <span 
              onClick={this.props.handleModalHtmlPopup}
              data-detail={this.state.value[1]}
              data-title={this.props.label + " " + this.state.value[0]}                                    
              data-close="ok-html-popup"
              className={"fault-detail-link"}>
              {this.state.value[0]}
            </span>
          </p>
        );        
      }
    }

    return (
      <div id={this.props.id} className={this.props.className}>
        <FormGroup>
          <ControlLabel>{this.props.label}</ControlLabel>
          {readOnly}     
          {input}
        </FormGroup>
      </div>
    );
  }
}

HtmlPopup.propTypes = {};

export default HtmlPopup;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/htmlPopup.jsx